import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { toast } from 'react-hot-toast';

// Helper function to validate onboarding data
export function validateOnboardingData(data: any): boolean {
  // Add any validation logic here if needed
  return true;
}

export async function completeOnboarding(userId: string): Promise<void> {
  if (!userId) {
    throw new Error('User ID is required');
  }

  try {
    const userRef = doc(db, collections.users, userId);
    
    await updateDoc(userRef, {
      onboardingCompleted: true,
      updatedAt: serverTimestamp()
    });
    
    console.log('Onboarding completed successfully for user:', userId);
  } catch (error: any) {
    console.error('Error completing onboarding:', error);
    toast.error(error.message || 'Failed to complete onboarding');
    throw error;
  }
}